import styled from "@emotion/styled";

export const Menu = styled.div`
  & h4,
  & a {
    font-size: 1.25rem;
  }

  & h4 {
    margin-top: 3rem;
    margin-bottom: 1.5rem;
  }

  & h4:first-child {
    margin-top: 0;
  }

  & p {
    max-width: 18rem;
    margin-bottom: 1.2rem;
    line-height: 150%;
  }
`;
